import "./Sobre.css";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import fotoDrBruno2 from "../../assets/img/fotoDrBruno2.png";

 function Sobre() {
  const navigate = useNavigate();

  const goToSection = (id) => {
    navigate("/", { state: { scrollTo: id } });
  };

  return (
    <section className="sobre-section" id="sobre">
      <div className="container">
        <div className="row align-items-center">

          {/* IMAGEM */}
          <div className="col-12 col-lg-5 scroll-reveal-opacity">
            <img
              src={fotoDrBruno2}
              alt="Dr. Bruno de Medeiros"
              className="sobre-img img-fluid"
            />
          </div>

          {/* TEXTO */}
          <div className="col-12 col-lg-7">

            <span className="sobre-tag scroll-reveal-opacity">
              Especialista em Urologia Reconstrutora
            </span>

            <h2 className="sobre-title scroll-reveal-opacity">
              Bruno de Medeiros Corrêa
            </h2>

            <p className="sobre-crm scroll-reveal-opacity">
              CRM: 52-1133411  |  RQE: 56580
            </p>

            <div className="sobre-text scroll-reveal-opacity">
              <p>
                Bruno de Medeiros Corrêa é médico urologista com formação de excelência pela UERJ. Sua trajetória é marcada pela dedicação técnica e pelo comprometimento com a resolução de quadros urológicos complexos.
              </p>

              <p>
                A consulta realiza um diagnóstico profundo e individualizado, indo além do sintoma para entender o impacto real da condição na vida do homem.
              </p>
            </div>

            {/* LISTA */}
            <ul className="sobre-list">
              <li className="scroll-reveal-opacity">
                <span className="material-symbols-outlined">school</span>
                <span>Graduação em Medicina — UERJ (2018)</span>
              </li>

              <li className="scroll-reveal-opacity">
                <span className="material-symbols-outlined">workspace_premium</span>
                <span>Especialização em Cirurgia Geral — Hospital Federal de Ipanema (2020-2022)</span>
              </li>

              <li className="scroll-reveal-opacity">
                <span className="material-symbols-outlined">medical_services</span>
                <span>Especialização em Urologia — UERJ (2022-2024)</span>
              </li>

              <li className="scroll-reveal-opacity">
                <span className="material-symbols-outlined">clinical_notes</span>
                <span>Especialização em Urologia Reconstrutora — UERJ (2025)</span>
              </li>

              <li className="scroll-reveal-opacity">
                <span className="material-symbols-outlined">history_edu</span>
                <span>Mestrado — UERJ (2025-2026)</span>
              </li>
            </ul>

          </div>
        </div>
      </div>
    </section>
  );
}

export default Sobre;